import React, { useLayoutEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import { getMidiaUrl } from '../../store/settings';
import Swiper from 'react-id-swiper';

const Destaques = () => {
    const noticias = useSelector(state => state.gazeta.noticiasCapa)
    const [noticia1, setNoticia1] = useState({})
    const [noticia2, setNoticia2] = useState({})
    const [noticia3, setNoticia3] = useState({})
    const [noticia4, setNoticia4] = useState({})
    const [noticia5, setNoticia5] = useState({})
    const [noticia6, setNoticia6] = useState({})
    const [noticia7, setNoticia7] = useState({})

    const ordenarNoticias = (noticias) => {
        // Filtra e ordena os destaques por data (mais recente primeiro)
        const destaques = noticias
            .filter(n => n.funcao === 'Destaque')
            .sort((a, b) => new Date(b.data) - new Date(a.data));

        // Pega o mais recente e o segundo mais recente, se existirem
        const destaqueMaisRecente = destaques[0];
        const destaquePenultimo = destaques[1];

        // Remove todos os destaques do array original
        const restante = noticias.filter(n => n.funcao !== 'Destaque');

        // Adiciona os demais destaques (do terceiro em diante) de volta à lista
        const outrosDestaques = destaques.slice(2);
        const listaFinal = [...restante, ...outrosDestaques];

        // Insere o destaque mais recente na posição 0, se houver
        if (destaqueMaisRecente) {
            listaFinal.splice(0, 0, destaqueMaisRecente);
        }

        // Insere o penúltimo na posição 6, ajustando o índice caso o primeiro já tenha sido inserido
        if (destaquePenultimo) {
            listaFinal.splice(6, 0, destaquePenultimo);
        }

        return listaFinal;
    }

    useLayoutEffect(() => {
        // se injetar direto a MaterialTable buga o redux
        let dados = noticias.map((item, key) => {
            var now = moment(new Date()); //todays date
            var end = moment(item.data, 'YYYY-MM-DDTHH:mm.Z'); // another date
            var duration = moment.duration(now.diff(end));
            var diferencaMin = duration.asMinutes();
            let tempo = ""
            if (diferencaMin < 60) tempo = `Há ${parseInt(diferencaMin)} ${parseInt(diferencaMin) > 1 ? "minutos" : "minuto"} `
            else if (diferencaMin < 1440) tempo = `Há ${parseInt(diferencaMin / 60)} ${parseInt(diferencaMin / 60) > 1 ? "horas" : "hora"}`
            else if (diferencaMin > 1440) tempo = `Há ${parseInt(diferencaMin / 1440)} ${parseInt(diferencaMin / 1440) > 1 ? "dias" : "dia"}`
            return Object.assign(
                {},
                item,
                { tempo },
                { data: moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("DD/MM/YYYY HH:mm") },
                { link: `/noticia/${moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("YYYY")}/${moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("MM")}/${moment(item.data, 'YYYY-MM-DDTHH:mm.Z').format("DD")}/${item.chave}` }
            )
        })
        Promise.all(dados).then(values => {
            let valuesDestaque = ordenarNoticias(values.slice(0, 7))
            if (valuesDestaque.length > 0) setNoticia1(valuesDestaque[0])
            if (valuesDestaque.length > 1) setNoticia2(valuesDestaque[1])
            if (valuesDestaque.length > 2) setNoticia3(valuesDestaque[2])
            if (valuesDestaque.length > 3) setNoticia4(valuesDestaque[3])
            if (valuesDestaque.length > 4) setNoticia5(valuesDestaque[4])
            if (valuesDestaque.length > 5) setNoticia6(valuesDestaque[5])
            if (valuesDestaque.length > 6) setNoticia7(valuesDestaque[6])
        })

    }, [noticias])

    const [swiper, setSwiper] = useState(null);
    const params = {
        slidesPerView: 3,
        spaceBetween: 25,

    };


    return (
        <>
            <div className="post_gallary_area theme3_bg padding-top-30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-xl-5">
                            <div className="single_post post_type6 border-radious7 xs-mb30">
                                <div className="post_img gradient1">
                                    <div className="img_wrap">
                                        <Link to={`${noticia1.link}`}>
                                            <img src={getMidiaUrl(noticia1.chaveMidia)} alt="Imagem da Notícia"
                                                style={isMobile ? null : { minHeight: 550 }}
                                            />
                                        </Link>
                                    </div>
                                    {
                                        /*
                                    <span className="tranding">
                                        <FontAwesome name="play" />
                                    </span>

                                        */
                                    }
                                </div>
                                <div className="single_post_text">

                                    <h4><Link to={`${noticia1.link}`}>
                                        {noticia1.titulo}
                                    </Link></h4>
                                    <div className="space-5" />

                                    <p className="post-p">{noticia1.subTitulo}</p>

                                    <div className="space-20" />
                                    <div className="meta meta_separator1">
                                        {noticia1.categorias ? noticia1.categorias.map((item, key, row) =>
                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                {`${item.nome}`.toUpperCase()}
                                                {key + 1 !== row.length ? " /" : null}
                                            </Link>
                                        ) : null}
                                        <Link to={`${noticia1.link}`}>{noticia1.tempo}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-xl-block col-xl-3">
                            <div className="white_bg padding15 border-radious5 sm-mt30">
                                {[noticia2, noticia3].map((item, i) => (
                                    < div key={i} className="single_post type14 mb10" >
                                        <div className="post_img">
                                            <div className="img_wrap">
                                                <Link to={`${item.link}`}>
                                                    <img src={getMidiaUrl(item.chaveMidia)} alt="thumb"

                                                        style={{ borderRadius: 10, marginBottom: 5 }} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="single_post_text">
                                            <h4><Link to={`${item.link}`}>{item.titulo}</Link></h4>
                                            <div className="meta4">
                                                {item.categorias ? item.categorias.map((itemN, key, row) =>
                                                    <Link key={key} to={`/categoria/${itemN.chave}`} style={{ marginRight: 5 }}>
                                                        {`${itemN.nome}`.toUpperCase()}
                                                        {key + 1 !== row.length ? " /" : null}
                                                    </Link>
                                                ) : null}
                                                <Link to={`${item.link}`}>{item.tempo}</Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="d-lg-block col-lg-4 col-xl-4">
                            <div className="single_post post_type3 post_type15 mb30 border-radious5 sm-mt30">
                                <div className="post_img">
                                    <div className="img_wrap">
                                        <Link to={`${noticia7.link}`}>
                                            <img src={getMidiaUrl(noticia7.chaveMidia)} alt="Imagem da Notícia"
                                                style={isMobile ? null : { minHeight: 330 }}
                                            />
                                        </Link>
                                    </div>
                                    {
                                        /*
                                    <span className="tranding border_tranding">
                                        <FontAwesome name="bolt" />
                                    </span>
    
                                        */
                                    }
                                </div>
                                <div className="single_post_text white_bg padding20">

                                    <h4><Link to={`${noticia7.link}`}>
                                        {noticia7.titulo}
                                    </Link></h4>
                                    <div className="space-10" />
                                    <p className="post-p">{noticia7.subTitulo}</p>
                                    <div className="space-20" />
                                    <div className="meta3">
                                        {noticia7.categorias ? noticia7.categorias.map((item, key, row) =>
                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                {`${item.nome}`.toUpperCase()}
                                                {key + 1 !== row.length ? " /" : null}
                                            </Link>
                                        ) : null}
                                        <Link to={`${noticia7.link}`}>{noticia7.tempo}</Link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="feature3 mt30" >
                        <div className="feature3_carousel owl-carousel nav_style1">
                            <Swiper getSwiper={setSwiper} {...params}>
                                {[noticia4, noticia5, noticia6].map((item, i) => (
                                    <div key={i} className="single_post type19 border-radious5 white_bg mb20"
                                        style={{
                                            minHeight: isMobile ? null : "350px",
                                        }}
                                    >
                                        <div className="post_img" >
                                            <div className="img_wrap">
                                                <Link to={`${item.link}`}>
                                                    <div style={{
                                                        width: "100%",
                                                        maxHeight: "200px",
                                                        overflow: "hidden"
                                                    }}>
                                                        <img src={getMidiaUrl(item.chaveMidia)} alt="Imagem da Notícia"
                                                            style={{
                                                                width: "100%",
                                                                height: isMobile ? "100px" : null,
                                                                objectFit: "cover", // corta se ultrapassar
                                                            }}

                                                        />
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="single_post_text padding15">
                                            <h4><Link to={`${item.link}`}>{item.titulo}</Link></h4>
                                            <div className="meta3">
                                                {item.categorias ? item.categorias.map((itemN, key, row) =>
                                                    <Link key={key} to={`/categoria/${itemN.chave}`} style={{ marginRight: 5 }}>
                                                        {`${itemN.nome}`.toUpperCase()}
                                                        {key + 1 !== row.length ? " /" : null}
                                                    </Link>
                                                ) : null}
                                                <Link to={`${item.link}`}>{item.tempo}</Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>

            </div >


            {
                /*
       <div className="post_gallary_area theme3_bg padding-top-30">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 col-xl-6">
                                {noticia1.chaveMidia ?
                                    <div className="single_post post_type6 border-radious7 xs-mb30 mb30">
                                        <div className="post_img gradient1">
                                            <div className="img_wrap">
                                                <Link to={`${noticia1.link}`}>
                                                    <img src={getMidiaUrl(noticia1.chaveMidia)} alt="Imagem da Notícia"
                                                        style={isMobile ? { height: 250 } : { minHeight: 500 }}
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="single_post_text">
                                            <h4>
                                                <Link to={`${noticia1.link}`}>
                                                    {noticia1.titulo}
                                                </Link>
                                            </h4>
                                            <div className="space-5" />
                                            <div className="space-20" />
                                            <div className="meta meta_separator1">
                                                {noticia1.categorias ? noticia1.categorias.map((item, key, row) =>
                                                    <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                        {`${item.nome}`}
                                                        {key + 1 !== row.length ? " /" : null}
                                                    </Link>
                                                ) : null}
                                                <Link to={`${noticia1.link}`}>{noticia1.tempo}</Link>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="single_post post_type3 post_type15 mb30 border-radious5 sm-mt30">
                                        <div className="single_post_text white_bg padding20">
                                            <div className="row" style={{ minHeight: 500 }}>
                                                <div className="col-lg-12 col-xl-12" >
                                                    <div className="meta3">
                                                        {noticia1.categorias ? noticia1.categorias.map((item, key, row) =>
                                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                                {`${item.nome}`}
                                                                {key + 1 !== row.length ? " /" : null}
                                                            </Link>
                                                        ) : null}
    
                                                        <Link to={`${noticia1.link}`}>{noticia1.tempo}</Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-xl-12">
                                                    <h4>
                                                        <Link to={`${noticia1.link}`} style={{ fontSize: 30, lineHeight: 1.2 }}>
                                                            {noticia1.titulo}
                                                        </Link>
                                                    </h4>
                                                    <div className="space-10" />
                                                    <p className="post-p">{noticia1.subTitulo}</p>
                                                    <div className="space-20" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
    
                            <div className="col-lg-8 col-xl-6">
                                {noticia2.chaveMidia ?
                                    <div className="single_post post_type3 post_type15 mb30 border-radious5 sm-mt30">
                                        <div className="single_post_text white_bg padding20">
                                            <div className="row">
                                                <div className="col-lg-5 col-xl-5">
                                                    <div className="post_img">
                                                        <div className="img_wrap" style={{ borderRadius: 5 }}>
                                                            <Link to={`${noticia2.link}`}>
                                                                <img
                                                                    src={getMidiaUrl(noticia2.chaveMidia)} alt="Imagem da Notícia"
                                                                    height={200}
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-7 col-xl-7">
                                                    <h4>
                                                        <Link to={`${noticia2.link}`}>
                                                            {noticia2.titulo}
                                                        </Link>
                                                    </h4>
                                                    <div className="space-10" />
                                                    <p className="post-p">{noticia2.subTitulo}</p>
                                                    <div className="space-20" />
                                                    <div className="meta3">
                                                        {noticia2.categorias ? noticia2.categorias.map((item, key, row) =>
                                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                                {`${item.nome}`}
                                                                {key + 1 !== row.length ? " /" : null}
                                                            </Link>
                                                        ) : null}
    
                                                        <Link to={`${noticia2.link}`}>{noticia2.tempo}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="single_post post_type3 post_type15 mb30 border-radious5 sm-mt30">
                                        <div className="single_post_text white_bg padding20">
                                            <div className="row">
                                                <div className="col-lg-12 col-xl-12">
                                                    <h4>
                                                        <Link to={`${noticia2.link}`} style={{ fontSize: 30, lineHeight: 1.1 }}>
                                                            {noticia2.titulo}
                                                        </Link>
                                                    </h4>
                                                    <div className="space-10" />
                                                    <p className="post-p">{noticia2.subTitulo}</p>
                                                    <div className="space-20" />
                                                    <div className="meta3">
                                                        {noticia2.categorias ? noticia2.categorias.map((item, key, row) =>
                                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                                {`${item.nome}`}
                                                                {key + 1 !== row.length ? " /" : null}
                                                            </Link>
                                                        ) : null}
    
                                                        <Link to={`${noticia2.link}`}>{noticia2.tempo}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
    
                                {noticia3.chaveMidia ?
                                    <div className="single_post post_type3 post_type15 mb30 border-radious5 sm-mt30">
                                        <div className="single_post_text white_bg padding20">
                                            <div className="row">
                                                <div className="col-lg-7 col-xl-7">
                                                    <h4>
                                                        <Link to={`${noticia3.link}`}>
                                                            {noticia3.titulo}
                                                        </Link>
                                                    </h4>
                                                    <div className="space-10" />
                                                    <p className="post-p">{noticia3.subTitulo}</p>
                                                    <div className="space-20" />
                                                    <div className="meta3">
                                                        {noticia3.categorias ? noticia3.categorias.map((item, key, row) =>
                                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                                {`${item.nome}`}
                                                                {key + 1 !== row.length ? " /" : null}
                                                            </Link>
                                                        ) : null}
    
                                                        <Link to={`${noticia3.link}`}>{noticia3.tempo}</Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-5 col-xl-5">
                                                    <div className="post_img">
                                                        <div className="img_wrap" style={{ borderRadius: 5 }}>
                                                            <Link to={`${noticia3.link}`}>
                                                                <img
                                                                    src={getMidiaUrl(noticia3.chaveMidia)}
                                                                    alt="col26"
                                                                    height={200}
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="single_post post_type3 post_type15 mb30 border-radious5 sm-mt30">
                                        <div className="single_post_text white_bg padding20">
                                            <div className="row">
    
                                                <div className="col-lg-12 col-xl-12">
                                                    <h4>
                                                        <Link to={`${noticia3.link}`} style={{ fontSize: 30, lineHeight: 1.1 }}>
                                                            {noticia3.titulo}
                                                        </Link>
                                                    </h4>
                                                    <div className="space-10" />
                                                    <p className="post-p">{noticia3.subTitulo}</p>
                                                    <div className="space-20" />
                                                    <div className="meta3">
                                                        {noticia3.categorias ? noticia3.categorias.map((item, key, row) =>
                                                            <Link key={key} to={`/categoria/${item.chave}`} style={{ marginRight: 5 }}>
                                                                {`${item.nome}`}
                                                                {key + 1 !== row.length ? " /" : null}
                                                            </Link>
                                                        ) : null}
                                                        <Link to={`${noticia3.link}`}>
                                                            {noticia3.tempo}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
    
    
                            </div>
    
                        </div>
                    </div>
                </div>
                */
            }
        </>
    );
};

export default Destaques;